import React from 'react';
import { Schema as SchemaComponent } from '../../components';
export var Schema = function (_a) {
    var schemaName = _a.schemaName, schema = _a.schema;
    if (!schema) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "panel-item--center px-8" },
            React.createElement("div", { className: "shadow rounded px-4 py-2 border bg-gray-200" },
                React.createElement(SchemaComponent, { schemaName: schemaName, schema: schema }))),
        React.createElement("div", { className: "w-full mt-4" })));
};
//# sourceMappingURL=Schema.js.map